// Component: ColorWithTextCard
// Author: Mito Are
import * as React from 'react';
import { Text, RichText } from '@sitecore-jss/sitecore-jss-react';
import BackgroundListCard from '@component/BackgroundListCard';
// import { RoutableRichText } from '../../react/RoutableRichText';

export default function ColorWithTextCard(props) {
  return (
    <>
      <BackgroundListCard
        variant={props.fields?.blockcolor?.fields?.Color?.value}
        bgTitle={<Text field={props.fields?.title} />}
        richtext={<RichText field={props.fields?.copy} />}
      />
    </>
  );
}
